import React, { useMemo, useState } from "react";
import infoIcon from "../../../../assets/images/svg/newDesign/infoicon.svg";
import "./../Steps.scss";
import { useMediaQuery } from "@mui/material";
import { Button, Form, Input, Select, Radio, Space } from "antd";
import { Row, Col, Container } from "react-bootstrap";
import { Popover } from "antd";
import { Label } from "evergreen-ui";

function BankDetail(props) {
  const isMobile = useMediaQuery("(max-width:767px)");
  //   const [requiredIban, setrequiredIban] = useState("");
  const [regexIban, setRegexIban] = useState("");

  const content = (
    <div>
      <p className="info"> CNIC of the account holder</p>
    </div>
  );

  const accountTitleRegex = /^[A-Za-z\s]+$/;
  const cnicNumberRegex = /^[0-9]+$/;

  // const validateIBANNumber = (_, value) => {
  //     const alphabeticRegex = /[a-zA-Z]/;
  //     const numericRegex = /^[0-9]+$/;

  //     const hasAlphabetic = alphabeticRegex.test(value);
  //     const hasNumeric = numericRegex.test(value);

  //     if (!hasNumeric) {
  //         return Promise.reject('IBAN number should be alphanumeric');
  //     }

  //     return Promise.resolve();
  // };

  // const validateIBANNumber = (_, value) => {
  //     const alphanumericRegex = /^[a-zA-Z0-9]+$/;

  //     const isAlphanumeric = alphanumericRegex.test(value);
  //     if(value === ''){
  //         console.log('erro')
  //     }
  //     else if (!isAlphanumeric) {
  //         // return Promise.reject('IBAN number should be alphanumeric');
  //         setRegexIban("IBAN number should be alphanumeric")
  //     }
  //     else {
  //         return Promise.resolve();
  //     }
  // };

  function generateArrayWithoutNumber() {
    let res = [];
    for (let i = 0; i <= 255; i++) {
      if (i >= 48 && i <= 57) {
      } else {
        res.push(String.fromCharCode(i));
      }
    }
    return res;
  }

  const arrayWithoutNumber = useMemo(() => generateArrayWithoutNumber(), []);

  const [showInfo, setShowInfo] = useState(false);

  const toggleInfo = () => {
    setShowInfo((prev) => !prev);
  };
  const [showCnicInfo, setShowCnicInfo] = useState(false);

  const toggleCnicInfo = () => {
    setShowCnicInfo((prev) => !prev);
  };

  return (
    <>
      <Row>
        <Col lg={12} md={12}>
          {!isMobile ? (
            <div className="infoBox">
              <img src={infoIcon} className="img-fluid" alt="info"></img>
              <p>
                Please enter your bank details for seamless payouts. Meri Sehat
                takes the security of your information very seriously and will
                never share or disclose it to any third parties without your
                consent. For help or queries, contact our customer support at
                (021)-111-111-111
              </p>
            </div>
          ) : (
            <div className="info-container">
              <img
                src={infoIcon}
                className="img-fluid"
                alt="info"
                onClick={toggleInfo}
                style={{ cursor: "pointer" }}
              />
              <h6 className="info-heading">
                Enter details for seamless payouts
              </h6>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.62109 17.2637L14.6211 12.2637L9.62109 7.26367"
                  stroke="#0F345A"
                  strokeWidth="1.69847"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              {/* Conditionally render info content */}
              {showInfo && (
                <div className="info-popup">
                  <p>
                    Please enter your bank details for seamless payouts. Meri
                    Sehat takes the security of your information very seriously
                    and will never share or disclose it to any third parties
                    without your consent. For help or queries, contact our
                    customer support at (021)-111-111-111
                  </p>
                </div>
              )}
            </div>
          )}
        </Col>
       <Col lg={6} md={6}>
          <Form.Item
            name="bankName"
            label="Bank Name* "
            rules={[
              {
                required: true,
                message: "Bank name is required",
              },
              {
                pattern: accountTitleRegex,
                message: "Bank name should only contain alphabetic characters.",
              },
            ]}
          >
            <Input placeholder="Enter bank name" />
          </Form.Item>
        </Col>
        <Col lg={6} md={6}>
          <Form.Item
            name="accountTitle"
            label="Account Title"
            rules={[
              {
                required: false,
                message: "Account title is required",
              },
              {
                pattern: accountTitleRegex,
                message:
                  "Account title should only contain alphabetic characters.",
                },
            ]}
          >
            <Input maxLength={30} placeholder="Enter account title" />
          </Form.Item>
        </Col>
        <Col lg={6} md={6}>
          <Form.Item
            name="ibanNumber"
            label="Account / IBAN Number*"
            rules={[
              {
                required: true,
                message: "Account or IBAN number is required",
              },
              {
                pattern: /^[a-zA-Z0-9]+$/,
                message: "Account/IBAN number should be alphanumeric only.",
              },
              {
                min: 8,
                message: "Account/IBAN number must be at least 8 characters.",
              },
              {
                max: 24,
                message: "Account/IBAN number cannot exceed 24 characters.",
              },
              // Custom validator to ensure it's not only alphabets
              {
                validator: (_, value) => {
                  if (!value || /[0-9]/.test(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "Account/IBAN number must include at least one number."
                    )
                  );
                },
              },
            ]}
          >
            <Input maxLength={24} placeholder="Enter IBAN number" />
          </Form.Item>
        </Col>
        <Col lg={6} md={6} className="condition_box ">
          <Form.Item
            name="cnic"
            rules={[
              {
                required: true,
                message: "CNIC number is required",
              },
              {
                pattern: cnicNumberRegex,
                message: "CNIC number should only in numbers",
              },
              { min: 13, message: "CNIC must be atleast 13 digits" },
            ]}
            label={
              <div>
                CNIC*{" "}
                <div className="popover_box1">
                  <img
                    src={infoIcon}
                    className="img-fluid"
                    alt="info"
                    onClick={toggleCnicInfo}
                  ></img>
                </div>
              </div>
            }
            extra={
              showCnicInfo && (
                <div className="cnic-info-container">
                  <div className="cnic-info-popup">
                    <p>CNIC of the account holder</p>
                  </div>
                </div>
              )
            }
          >
            <Input
              placeholder="Enter CNIC"
              maxLength={13}
              onKeyDown={(evt) =>
                arrayWithoutNumber.includes(evt.key) && evt.preventDefault()
              }
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default BankDetail;
